export default __webpack_public_path__ + "static/media/explore1.96f62cef.png";